import { render, staticRenderFns } from "./salary-previewsend.vue?vue&type=template&id=6a5425ac&scoped=true&"
import script from "./salary-previewsend.vue?vue&type=script&lang=js&"
export * from "./salary-previewsend.vue?vue&type=script&lang=js&"
import style0 from "./salary-previewsend.vue?vue&type=style&index=0&id=6a5425ac&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5425ac",
  null
  
)

export default component.exports